import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import React from 'react';
import { translate } from '../../../../../common/intl';
import { TextField } from '../../../../components/forms/fields-next';
import Text from '../../../../components/Text';
import styles from './styles';

interface Props {
  value: string
  replacingAddress?: string
  onCancel: () => void
  onSave: () => void
  onChange: (address: string) => void
}

const EditingComponent: React.FC<Props> = ({
  value,
  replacingAddress,
  onCancel,
  onSave,
  onChange,
}) => {
  const classes = styles();
  return (
    <>
    <Box className={classes.boxContainer}>
      <TextField
        className={classes.textField}
        defaultValue={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button
        className={classes.cancelButton}
        onClick={onCancel}>
          {translate('common.cancel')}
      </Button>
      <Button
        className={classes.saveButton}
        onClick={onSave}>
        {translate('common.save')}
      </Button>
    </Box>
    {!isEmpty(replacingAddress) && (
    <Box className={classes.replacingBox}>
      <Typography variant="h5" className={classes.replacingText}>
        <Text message={translate('common.replacing')} />
      </Typography>
      <FontAwesomeIcon icon={regular('arrow-right')} className={classes.arrowIcon} />
      <span className={classes.replacingText}>{replacingAddress}</span>
    </Box>
    )}
    </>
  );
};

export default EditingComponent;
